<template>
  <div class="roi_form_wrap">
    <ul>
      <li v-for="(field, index) in form_data.fields" :key="field.id">
        <span v-if="form_data.selected_goal==3">
        <Slider
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'slider'"
        />
        <Radio
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'radio'"
        />
        <div class="title_wrap" v-if="field.type == 'title'">
          <h4>{{ field.label }}</h4>
        </div>
        </span>
        <span v-if="form_data.selected_goal==2 && index < 14">
        <Slider
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'slider'"
        />
        <Radio
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'radio'"
        />
        <div class="title_wrap" v-if="field.type == 'title'">
          <h4>{{ field.label }}</h4>
        </div>
        </span>
        <span v-if="form_data.selected_goal==1 && index < 14">
        <Slider
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'slider'"
        />
        <Radio
          :field="field"
          :fields="form_data.fields"
          :index="index"
          :updateFormData="updateFormData"
          v-if="field.type == 'radio'"
        />
        <div class="title_wrap" v-if="field.type == 'title'">
          <h4>{{ field.label }}</h4>
        </div>
        </span>
      </li>
      <li>
        <button v-on:click="computeFormData(form_data.fields)">CALCULATE</button>
        <p class="errors" v-if="form_data.errors && clicked">
          {{
            form_data.errors
              ? "Error: Please select all options to compute Results and Recommendation"
              : ""
          }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import Slider from "./Slider";
import Radio from "./Radio";

export default {
  name: "RoiCalculator",
  props: {
    form_data: Object,
    title: String,
    changeStep: Function,
    no_of_customers: Number,
    updateFormData: Function
  },
  components: {
    Slider,
    Radio
  },
  data() {
    return {
      clicked:false
    };
  },
  methods: {
    computeFormData: function(data) {
        this.updateFormData(data);
        this.clicked = true;
      if (this.form_data.errors == false) {
        this.changeStep(3);
      }
    }
  }
};
</script>

<style src="@vueform/slider/themes/default.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  margin: 0;
  padding: 0;
  text-align: left;
}
ul li h4 {
  background: transparent linear-gradient(90deg, #3e457b 0%, #3e7bae 100%) 0% 0%
    no-repeat padding-box;
  border: 3px solid #ffffff;
  border-radius: 28px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  display: inline-flex;
  padding: 10px 20px;
  font-size: 1em;
  font-family: "Roboto Slab", serif;
}

button {
  text-align: center;
  letter-spacing: 0px;
  color: #ef8e45;
  opacity: 1;
  border: 1px solid #ef8e45;
  border-radius: 6px;
  opacity: 1;
  padding: 10px 20px;
  font-size: 1em;
  font-weight: 500;
  font-family: "Roboto Slab", serif;
  cursor: pointer;

  background: #ef8e45 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  display: block;
}
.roi_form_wrap {
  padding: 80px 80px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 18px #0000001a;
  border-radius: 0 0 20px 20px;
  opacity: 1;
}
ul li .title_wrap {
  position: relative;
}
ul li .title_wrap:before {
  content: "";
  position: absolute;
  right: 0px;
  border-top: 1px dashed #d1d5db;
  display: block;
  left: 0;
  z-index: 1;
  top: 48%;
}
ul li .title_wrap h4 {
  position: relative;
  z-index: 2;
}
.errors {
  text-align: center;
  color: #f00;
    margin-top: 15px;
}
</style>
